import { render, staticRenderFns } from "./SectionConfirmNewQuote.vue?vue&type=template&id=f33b0e6e&"
import script from "./SectionConfirmNewQuote.vue?vue&type=script&lang=js&"
export * from "./SectionConfirmNewQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports